import { Combobox } from '@/global/components/Combobox'
import { Empresa, empresas } from 'service/api'
import { useStore } from 'store'
import { HELPER_TEXT_FORM, SelectProps } from './types'

interface IProps extends Omit<SelectProps, 'variant'> {
    children?: never
    /**
     * `form` = preset para formulários: largura 100%, size `medium` e
     * helperText reservado para manter o alinhamento com os demais campos.
     */
    variant?: SelectProps['variant'] | 'form'
}

export function SelectEmpresa({
    size,
    variant = 'filled',
    width,
    helperText,
    disabled,
    hideWhenSingle = false,
    className,
}: IProps) {
    const isForm = variant === 'form'
    const selectSize = size ?? (isForm ? 'medium' : 'small')
    const selectWidth = width ?? (isForm ? '100%' : 260)
    const selectHelperText =
        helperText ?? (isForm ? HELPER_TEXT_FORM : undefined)
    const [companyId, setEmpresaId] = useStore(state => [
        state.companyId,
        state.setCompanyId,
    ])
    const {
        data = [],
        isFetched,
        isFetching,
    } = empresas.useFetch({
        refetchOnWindowFocus: false,
    })

    if (hideWhenSingle && data.length <= 1 && isFetched) {
        return null
    }

    const options = [...data].sort((a, b) =>
        a.nomeFantasia.localeCompare(b.nomeFantasia),
    )
    const selectedEmpresa = data.find(e => e.id === companyId) ?? null

    return (
        <div style={{ width: selectWidth }} className={className}>
            <Combobox<Empresa>
                label="Empresa"
                size={selectSize}
                variant={variant === 'outlined' ? 'outlined' : 'filled'}
                placeholder="Selecione uma empresa"
                options={options}
                value={selectedEmpresa}
                onChange={value => {
                    if (!value) return
                    setEmpresaId(value.id)
                    useStore.setState({ company: value })
                }}
                getOptionLabel={option => option?.nomeFantasia || ''}
                getOptionKey={option => String(option.id)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={isFetching}
                noOptionsText="Nenhuma empresa"
                helperText={selectHelperText}
                disabled={disabled}
            />
        </div>
    )
}
